import { useTranslation } from 'next-i18next';
import { useEffect } from 'react';

import { requestUpdateFmDraft, useAppDispatch, useAppSelector } from '../state';

export function useFmAutoSave() {
  const draft = useAppSelector((state) => state.fm.fmDraft);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    let timer;
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (draft?._dirty) {
        dispatch(requestUpdateFmDraft());
      }
    }, 500);
    return () => {
      clearTimeout(timer);
    };
  }, [dispatch, draft?._dirty, t]);
}
